import React from 'react';
import { defineCommand } from '../../../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../../../concepts/commands/CommandDispatcher';
import { Button, Colors } from '../../../../../ui';
import { Badge } from '../../../../../ui/Badge';
import { useResolve } from '../../../../Container';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { jiraImport } from '../../../atlassian/AtlassianCommands';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const ImportJiraIssuesToolCallView = React.memo(({ args }: ToolCallPart) => {
    const dispatch = useResolve(CommandDispatcher);
    const { jiraProjectId, jql, count = 50 } = args;

    const onImport = () => {
        // TODO: Implement import functionality
        dispatch(jiraImport, [null, jql]);
    };

    return <Flexer padding=".5">
        <Flexer flex="row" align="center" gap=".5">
            <Badge color={Colors.positive}>Import Jira Issues</Badge>
        </Flexer>
        <Flexer height=".5" />
        <Copy style={{ whiteSpace: 'pre-wrap' }}>
            JQL: {jql}
        </Copy>
        <Flexer height=".5" />
        <Button onAction={onImport}>
            Import Issues
        </Button>
    </Flexer>;
});

export const ImportJiraIssuesToolSupport = AssitantToolSupport({
    toolName: 'importJiraIssues',
    ui: ImportJiraIssuesToolCallView,
    command: defineCommand(
        'assistantImportJiraIssues',
        null,
        (cc, [args]: [any]) => {
            return true;
        }
    )
});
